import React from 'react';
import './column.scss';
export var Column = function (_a) {
    var children = _a.children, mb = _a.mb, spaced = _a.spaced, hiddenInSmallerScreens = _a.hiddenInSmallerScreens, extendClass = _a.extendClass;
    var columnClasses = 'c-column';
    if (mb) {
        columnClasses += " u-mb-".concat(mb);
    }
    if (spaced) {
        columnClasses += " c-column__spaced";
    }
    if (hiddenInSmallerScreens) {
        columnClasses += " c-column__smaller_screens_hidden";
    }
    if (extendClass) {
        columnClasses += " ".concat(extendClass);
    }
    return React.createElement("div", { className: columnClasses }, children);
};
